import { render, staticRenderFns } from "./ShelvesNumber.vue?vue&type=template&id=248cf391&scoped=true&"
import script from "./ShelvesNumber.vue?vue&type=script&lang=js&"
export * from "./ShelvesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cf391",
  null
  
)

export default component.exports